import { LocationDto } from "app/data/management/models/location.dto";
import { BankDto } from "app/data/management/models/bank.dto";
import { CurrencyDto } from "app/data/management/models/currency.dto";
import { DefinitionDto } from "@app/modules/shared/model/definition.dto";
import { ShippingAddressDto } from "@dashboard/modules/finance-management/shipping-address/model/shipping-address.dto";
import { SectorDto } from "@dashboard/modules/management/sector/model/sector.dto";

export class CurrentAccountDto extends DefinitionDto {
  type?: string;
  is_private?: string;
  identity_num?: string;
  tax_office?: string;
  tax_num?: string;
  sector?: SectorDto;
  currency?: CurrencyDto;
  country?: LocationDto;
  region?: LocationDto;
  state?: LocationDto;
  city?: LocationDto;
  county?: LocationDto;
  address?: string;
  phone?: string;
  phone2?: string;
  fax_num?: string;
  email_address?: string;
  web_address?: string;
  special_code?: string;
  special_code2?: string;
  special_code3?: string;
  special_code4?: string;
}
